enum SizeAlias {
  none = 'none',
  line = 'line',
  xs = 'xs',
  sm = 'sm',
  base = 'base',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = 'xxl',
}

export type SizeScaleIndex = number | keyof typeof SizeAlias;
export type SizeScale = {
  [index: number]: string;
  [index: string]: string;
};

type SizeScaleBuilderConfig = {
  increment: number;
  unit: string;
  count: number;
};

function buildSizeScale({ increment, unit, count }: SizeScaleBuilderConfig): SizeScale {
  const sizes: SizeScale = {};
  /* eslint-disable-next-line no-plusplus */
  for (let i = 0; i <= count; i++) {
    const value = i * increment;
    sizes[i] = `${value}${unit}`;
  }
  return sizes;
}

export const sizeScale = buildSizeScale({ increment: 0.25, unit: 'rem', count: 20 });

export const sizeAliases: SizeScale = {
  [SizeAlias.none]: '0',
  [SizeAlias.line]: '1px',
  [SizeAlias.xs]: sizeScale[1],
  [SizeAlias.sm]: sizeScale[2],
  [SizeAlias.base]: sizeScale[4],
  [SizeAlias.md]: sizeScale[6],
  [SizeAlias.lg]: sizeScale[8],
  [SizeAlias.xl]: sizeScale[12],
  [SizeAlias.xxl]: sizeScale[16],
};

export const sizes: SizeScale = {
  ...sizeAliases,
  ...sizeScale,
};
